// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dwO8","rootMobile":"styles_rootMobile__3whEz"};